/* GOG – anteprima carrello: si apre dopo "aggiungi al carrello" e dall'icona del carrello */
(function () {
  'use strict';
  if (window.__gogCart) return; window.__gogCart = true;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var drawer, backdrop, content, busy = false;

  function setCount(n) {
    Array.prototype.forEach.call(document.querySelectorAll('[data-cart-count]'), function (el) { el.textContent = n; });
    Array.prototype.forEach.call(document.querySelectorAll('.cart-badge'), function (el) { el.classList.toggle('visible', n > 0); });
  }
  function load() {
    content.classList.add('loading');
    return fetch(root + '?section_id=gog-cart-drawer', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var src = doc.querySelector('[data-gcd]');
        if (!src) throw new Error('no content');
        content.innerHTML = src.innerHTML;
        setCount(parseInt(src.getAttribute('data-count'), 10) || 0);
        content.classList.remove('loading');
      });
  }
  function open() {
    if (!drawer) return;
    drawer.classList.add('open'); backdrop.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false'); document.body.classList.add('gog-cart-open');
    load().catch(function () { window.location.href = root + 'cart'; });
  }
  function close() {
    drawer.classList.remove('open'); backdrop.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true'); document.body.classList.remove('gog-cart-open');
  }
  function change(key, qty) {
    if (busy) return; busy = true; content.classList.add('loading');
    _fetch(root + 'cart/change.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
      .then(function () { return load(); })
      .catch(function () { content.classList.remove('loading'); })
      .then(function () { busy = false; });
  }

  /* Dopo ogni aggiunta al carrello (fatta dal sito) apre o aggiorna l'anteprima */
  var _fetch = window.fetch.bind(window);
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = _fetch(input, init);
    if (/\/cart\/add(\.js)?(\?|$)/.test(url)) p.then(function (r) { if (r && r.ok) setTimeout(open, 60); }).catch(function () {});
    return p;
  };

  function init() {
    drawer = document.getElementById('gog-cart-drawer'); if (!drawer) return;
    backdrop = document.querySelector('.gog-cart-backdrop'); content = drawer.querySelector('.gcd-content');
    backdrop.addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('open')) close(); });
    drawer.addEventListener('click', function (e) {
      var t = e.target;
      if (t.closest('.gcd-close')) { close(); return; }
      var q = t.closest('[data-gcd-key]');
      if (q) { e.preventDefault(); change(q.getAttribute('data-gcd-key'), parseInt(q.getAttribute('data-gcd-qty'), 10)); }
    });
    var onCartPage = document.body.classList.contains('template-cart');
    document.addEventListener('click', function (e) {
      if (onCartPage || e.metaKey || e.ctrlKey || e.shiftKey || e.button) return;
      var a = e.target.closest('.header a[href$="/cart"], #toast a[href$="cart"]');
      if (!a) return;
      e.preventDefault(); open();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
